// test1203
(1203 && 0);
